import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['selector', 'experience']

  connect() {
    if (!this.hasSelectorTarget) {
      this.showAllExperiences()
      return
    }

    const packageOptions = this.selectorTarget.options.length
    if (packageOptions <= 2) { // 1 option + "Select a package" placeholder
      this.selectorTarget.closest('.package-selector-wrapper').style.display = 'none'
      this.showAllExperiences()
    }
  }

  filterExperiences() {
    // TODO: filter by selected package via data-package-ids/data-package-id
    this.showAllExperiences()
  }

  showAllExperiences() {
    this.experienceTargets.forEach(experience => {
      experience.classList.remove('hidden')
    })
  }
}
